import { createFileRoute } from '@tanstack/react-router';

import { ensureRecord } from '@/app/guards';
import { StageCatalogPage, bankQuery, stagesQuery } from '@/features/banks-products';
import { NotFoundView } from '@/features/shell';

export const Route = createFileRoute('/_app/banks/$bankId/stages')({
  loader: async ({ context, params }) => {
    const [bank] = await Promise.all([ensureRecord(context.queryClient.query({ ...bankQuery(params.bankId), staleTime: 'static' })), context.queryClient.query({ ...stagesQuery(params.bankId), staleTime: 'static' })]);
    return { crumb: bank.name };
  },
  notFoundComponent: function BankNotFound() {
    const { bankId } = Route.useParams();
    return <NotFoundView reference={bankId} />;
  },
  component: function BankCatalog() {
    const { bankId } = Route.useParams();
    return <StageCatalogPage bankId={bankId} />;
  },
});
